(() => {
  const EM_DASH = '\u2014';
  const SKIP_SELECTOR = 'script, style, noscript, textarea, code, pre, [contenteditable="true"], [data-preserve-copy]';
  const ATTRIBUTE_NAMES = ['aria-label', 'title', 'placeholder', 'alt', 'content'];
  const ATTRIBUTE_SELECTOR = '[aria-label], [title], [placeholder], [alt], meta[content]';

  const normalizeCopy = (value) => {
    if (typeof value !== 'string' || !value.includes(EM_DASH)) return value;

    return value
      .replace(/^\s*\u2014\s*/, '')
      .replace(/\s*\u2014\s*$/, '')
      .replace(/\s*\u2014\s*(?=\d)/g, ' ')
      .replace(/\s*\u2014\s*/g, ', ')
      .replace(/\s+,/g, ',')
      .replace(/,\s*([,.;:!?])/g, '$1')
      .replace(/[ \t]{2,}/g, ' ');
  };

  const isSkipped = (element) => Boolean(element && element.closest(SKIP_SELECTOR));

  const cleanTextNode = (node) => {
    if (!node || node.nodeType !== Node.TEXT_NODE || isSkipped(node.parentElement)) return;
    const updated = normalizeCopy(node.nodeValue);
    if (updated !== node.nodeValue) node.nodeValue = updated;
  };

  const cleanAttributes = (element) => {
    if (!element || element.nodeType !== Node.ELEMENT_NODE || isSkipped(element)) return;

    ATTRIBUTE_NAMES.forEach((attributeName) => {
      if (!element.hasAttribute(attributeName)) return;
      const current = element.getAttribute(attributeName);
      const updated = normalizeCopy(current);
      if (updated !== current) element.setAttribute(attributeName, updated);
    });
  };

  const cleanSubtree = (root) => {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      cleanTextNode(root);
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE || isSkipped(root)) return;

    cleanAttributes(root);

    const textWalker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let textNode = textWalker.nextNode();
    while (textNode) {
      cleanTextNode(textNode);
      textNode = textWalker.nextNode();
    }

    root.querySelectorAll(ATTRIBUTE_SELECTOR).forEach(cleanAttributes);
  };

  const start = () => {
    cleanSubtree(document.documentElement);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          cleanTextNode(mutation.target);
          return;
        }

        if (mutation.type === 'attributes') {
          cleanAttributes(mutation.target);
          return;
        }

        mutation.addedNodes.forEach(cleanSubtree);
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ATTRIBUTE_NAMES,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
